const mediumRiskProcess = (processStats) => {
  return processStats?.departments?.reduce(
    (value, department) => value + department.risks?.medium,
    0,
  )
}

export default mediumRiskProcess
